import { useParams } from "react-router-dom";
import styles from "./styles.module.scss";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { message, Select } from "antd";
import { DropdownSuffix } from "icons";
import { useEffect, useState } from "react";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { useCurrentUserContext } from "providers";
import { UpdateCaseStatus } from "../update-case-status";

export const FileNumberSmile = ({
  caseTotalStatuses,
  caseStatus,
  caseStatusLocal,
  setCaseStatusLocal,
}) => {
  const { caseId } = useParams();
  const { translator } = useLanguageTranslator();
  const reminderTableTrans = translator("caseDetail.reminder.historyTable");
  const { user } = useCurrentUserContext();

  const [
    updateStatus,
    {
      data: updateStatusData,
      isLoading: updateStatusLoading,
      error: updateStatusErr,
    },
  ] = UseLazyApiCallV2({
    url: "/update_status",
    method: "POST",
  });

  async function handleSelectStatus(statusId) {
    setCaseStatusLocal(statusId);
    try {
      const res = await updateStatus({
        params: {
          case_id: caseId,
          statusId,
          loggedUser: user?.email,
        },
      });

      if (res?.status === "SUCCESS") {
        message.success(res?.message);
        // if (refetchCount) {
        //   refetchCount();
        // }
        // refetchReminderHistory();
      }
    } catch (error) {
      console.log({ error });
    }
  }

  const statusDropdownData = caseTotalStatuses?.map((item) => ({
    label: item?.settingName,
    value: item?.settingId,
  }));

  return (
    <div className={styles.container}>
      <h3 className={styles.caseId}>
        Aktenzeichen Smile - <span>{caseId}</span>
      </h3>
      {/* <UpdateCaseStatus
        caseStatus={caseStatus}
        caseStatusLocal={caseStatusLocal}
        caseTotalStatuses={caseTotalStatuses}
        setCaseStatusLocal={setCaseStatusLocal}
      /> */}
    </div>
  );
};
